import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  dialogWrapper: {
    maxWidth: "800px",
    width: "100%",
  },
  tableContainer: {
    "& .MuiDataGrid-root": {
      padding: "0",
      overflow: "hidden",
      background: theme.palette.background.secondary,
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
        padding: "0",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row": {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.background.gray_200}`,
      borderLeft: "none",
      borderRight: "none",
    },
  },
}));
